module.exports = __webpack_public_path__ + "img/weixin.bf97db45.jpg";